import {hasPermission, useUser} from "../../../../misc/Permission";
import {
    StringCol,
    Table, ViewOnly,
} from "../../../../misc/scroller/Table";
import {priceTableName} from "./Pricing";
import {useProjectId} from "../ProjectName";
import React, {useContext} from "react";
import {ManagerLockContext} from "../ProjectActions";
import {PriceLine2} from "./Frames";
import {
    commonPricingColumns3,
    commonPricingColumns3Start,
    sovCellCustomize,
    sovColumns,
    usePricingKit2
} from "./usePricingKit2";
import {getAll} from "../../../logistics/routes/useGetAll";
import {api} from "../../../../api/API";
import {SidePricingPanel} from "./SidePricingPanel";
import {onPricingChangeWrap} from "./PricingTabs";
import {useCheckboxExtSetupData} from "../../manage/sov/CheckboxExtProvider";

export function Doors(props: {
    kind: "hm" | "wd"
    filterByChangeset?: boolean;
    sov?: number;
}) {
    const project = useProjectId();
    const {locked} = useContext(ManagerLockContext)
    const u = useUser();

    const kit = usePricingKit2(project);
    const checkboxAllData = useCheckboxExtSetupData();

    if(!u) return null;
    if(kit.Loading) return <>{kit.Loading}</>

    return (
        <div style={{display: "flex", flex: 1, flexDirection: "row", alignItems: "stretch"}}>
            <Table<PriceLine2>
                name={priceTableName(project, props.kind)}
                globalPrefsName={priceTableName(0, props.kind)}
                cellCustomize={
                    props.sov ? sovCellCustomize(props.sov) :
                    props.filterByChangeset ?
                        undefined :
                        kit.cellCustomize
                }
                locked={locked && !hasPermission(u, "EditShopDrawingWhenLockedToManager")}
                fetch={async (ctx) => checkboxAllData(getAll(ctx, offset =>
                    api.pricing.list({
                        project: project, offset,
                        previewChangeset: kit.sessionId,
                        category: "door-" + props.kind as any,
                        filterByChangeset: props.filterByChangeset,
                        refunded: props.filterByChangeset ? false : undefined,
                        forSovLink: !!props.sov,
                    })
                ))}
                columns={[
                    ...sovColumns(props.sov),
                    ...commonPricingColumns3Start(),
                    ViewOnly(StringCol("Side", "openingSubtype")),
                    ViewOnly(StringCol("Width", "door.width")),
                    ViewOnly(StringCol("Height", "door.height")),
                    ViewOnly(StringCol("Handing", "door.handing")),
                    ViewOnly(StringCol("Label", "door.label")),
                    ViewOnly(StringCol("Series", "door.series")),
                    ViewOnly(StringCol("Material", "door.material")),
                    ViewOnly(StringCol("Finish", "door.finish")),
                    ViewOnly(StringCol("Gauge", "door.gauge")),
                    ViewOnly(StringCol("Thickness", "door.thickness")),
                    ViewOnly(StringCol("Elev", "door.elevation")),
                    ViewOnly(StringCol("Core", "door.core")),
                    ViewOnly(StringCol("Seam", "door.seam")),
                    ...commonPricingColumns3(u, kit.markup?.frame + "%", props.sov),
                ]}
                columnDeps={[u, kit.markup, props.sov]}
                fetchDeps={[project, kit.sessionId, props.kind, props.filterByChangeset, props.sov]}
                onChange={(input) => onPricingChangeWrap(api.pricing.upsert(input))}
            />
            {props.filterByChangeset && <SidePricingPanel
                kind={("door-" + props.kind) as any}
                preColumns={[
                    ViewOnly(StringCol("Side", "openingSubtype")),
                ]}
                postColumns={[
                    ViewOnly(StringCol("Width", "door.width")),
                    ViewOnly(StringCol("Height", "door.height")),
                    ViewOnly(StringCol("Handing", "door.handing")),
                    ViewOnly(StringCol("Label", "door.label")),
                    ViewOnly(StringCol("Series", "door.series")),
                    ViewOnly(StringCol("Material", "door.material")),
                    ViewOnly(StringCol("Finish", "door.finish")),
                    ViewOnly(StringCol("Gauge", "door.gauge")),
                    ViewOnly(StringCol("Thickness", "door.thickness")),
                    ViewOnly(StringCol("Elev", "door.elevation")),
                    ViewOnly(StringCol("Core", "door.core")),
                    ViewOnly(StringCol("Seam", "door.seam")),
                ]}
            />}
        </div>
    )
}
